/* VIPA preview-only registration finder enhancement, visual only. */
(function () {
  'use strict';
  function enhance() {
    var root = document.querySelector('#MainContent .reg-finder-container');
    if (!root) return;
    var form = root.querySelector('form#reg-finder-form');
    var input = form && form.querySelector('input#reg[name="reg"]');
    var block = form && form.closest('.reg-finder__block');
    if (!form || !input || !block || form.getAttribute('data-vipa-design-ready') === '1') return;
    form.setAttribute('data-vipa-design-ready', '1');
    input.setAttribute('placeholder','AB12 CDE');
    input.setAttribute('aria-label','Vehicle registration');
    input.setAttribute('autocapitalize','characters');
    input.setAttribute('spellcheck','false');
    if (!block.querySelector('.vipa-hero-reg-label')) {
      var label = document.createElement('label');
      label.className='vipa-hero-reg-label';
      label.htmlFor='reg';
      label.textContent='Enter your UK registration';
      block.insertBefore(label,form);
    }
    if (!root.querySelector('.vipa-hero-reg-support')) {
      var support = document.createElement('div');
      support.className='vipa-hero-reg-support';
      support.setAttribute('aria-label','Why shop with VIPA');
      ['✓ Exact vehicle fit','✓ No adapters','✓ Free UK delivery'].forEach(function(item) {
        var chip = document.createElement('span');
        chip.textContent=item;
        support.appendChild(chip);
      });
      block.insertAdjacentElement('afterend',support);
    }
    var browse = document.getElementById('vipa-browse-wipers-by-make');
    if (browse && !root.querySelector('.vipa-hero-reg-browse')) {
      var link = document.createElement('a');
      link.className='vipa-hero-reg-browse';
      link.href='#vipa-browse-wipers-by-make';
      link.textContent="Don't have your reg? Browse by make ↓";
      support.insertAdjacentElement('afterend',link);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded',enhance,{once:true});
  } else {
    enhance();
  }
  window.addEventListener('load',enhance,{once:true});
})();

/* VIPA confirmed vehicle image — persistent, registration-matched and trusted-host only.
   Uses the exact vehicle image returned by the registration provider; never guesses a car. */
(function () {
  'use strict';
  var keyV3 = 'vipa-confirmed-vehicle-image-v3';
  var keyV2 = 'vipa-confirmed-vehicle-image-v2';
  var localTtl = 24 * 60 * 60 * 1000;
  var sessionTtl = 4 * 60 * 60 * 1000;

  function normalisePlate(value) {
    return String(value || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
  }

  function validatedImageUrl(value) {
    try {
      var u = new URL(String(value || ''), window.location.href);
      if (u.protocol !== 'https:') return '';
      var host = u.hostname.toLowerCase();
      var path = u.pathname || '';
      if (/vehicle-placeholder/i.test(path)) return '';

      if (host === 'vehicleimages.ukvehicledata.co.uk' && path.indexOf('/s3/') === 0) return u.href;
      if ((host === 'static.vipaconversion.com' || host === 'www.vipaconversion.com' || host === 'vipaconversion.com') &&
          (path.indexOf('/images/') === 0 || path.indexOf('/assets/img/car/') === 0)) return u.href;
      if ((host === 'www.vipacarparts.com' || host === 'vipacarparts.com') && path.indexOf('/assets/img/car/') === 0) return u.href;
      return '';
    } catch (e) { return ''; }
  }

  function imageFromElement(img) {
    if (!img) return '';
    var candidates = [
      img.currentSrc,
      img.getAttribute('src'),
      img.getAttribute('data-src'),
      img.getAttribute('data-image'),
      img.getAttribute('data-original')
    ];
    var srcset = img.getAttribute('srcset') || img.getAttribute('data-srcset') || '';
    if (srcset) {
      srcset.split(',').forEach(function (part) {
        candidates.push((part.trim().split(/\s+/)[0] || ''));
      });
    }
    for (var i = 0; i < candidates.length; i++) {
      var good = validatedImageUrl(candidates[i]);
      if (good) return good;
    }
    return '';
  }

  function writeInfo(info) {
    if (!info || !info.registration || !info.image) return;
    var raw = JSON.stringify(info);
    try { sessionStorage.setItem(keyV3, raw); } catch (e) {}
    try { localStorage.setItem(keyV3, raw); } catch (e) {}
  }

  function clearInfo() {
    try { sessionStorage.removeItem(keyV3); sessionStorage.removeItem(keyV2); } catch (e) {}
    try { localStorage.removeItem(keyV3); localStorage.removeItem(keyV2); } catch (e) {}
  }

  function readStorage(store, key, ttl) {
    try {
      var value = JSON.parse(store.getItem(key) || 'null');
      if (!value || !value.registration || !value.image || !value.capturedAt) return null;
      if (Date.now() - Number(value.capturedAt) > ttl) return null;
      var image = validatedImageUrl(value.image);
      if (!image) return null;
      value.image = image;
      return value;
    } catch (e) { return null; }
  }

  function readStoredInfo() {
    return readStorage(sessionStorage, keyV3, sessionTtl) ||
           readStorage(localStorage, keyV3, localTtl) ||
           readStorage(sessionStorage, keyV2, sessionTtl);
  }

  function imageFromRegResult(expectedPlate) {
    try {
      var data = JSON.parse(localStorage.getItem('regResult') || 'null');
      if (!data) return null;
      var reg = normalisePlate(data.reg || data.registration || '');
      if (!reg || reg !== normalisePlate(expectedPlate)) return null;
      var keys = ['image','imageUrl','image_url','vehicleImage','vehicle_image','vehicleImageUrl','vehicle_image_url','photo','photoUrl','photo_url'];
      for (var i = 0; i < keys.length; i++) {
        var image = validatedImageUrl(data[keys[i]]);
        if (image) return { registration: reg, image: image, capturedAt: Date.now() };
      }
    } catch (e) {}
    return null;
  }

  /* Capture the exact vehicle image only when the customer confirms this is their vehicle. */
  document.addEventListener('click', function (event) {
    var clicked = event.target && event.target.closest && event.target.closest('button, a, input[type="submit"], input[type="button"], [role="button"]');
    if (!clicked || !clicked.closest('#vehicle-confirm__modal')) return;
    var answer = String(clicked.textContent || clicked.value || '').trim();
    if (/^no\b/i.test(answer)) {
      clearInfo();
      return;
    }
    if (!/^yes\b[\s\S]*\bmy\s+vehicle\b/i.test(answer)) return;

    var picture = document.querySelector('#vehicle-confirm__modal img#vehicleImage');
    var image = imageFromElement(picture);
    var input = document.querySelector('#reg-finder-form input#reg, #reg-finder-form input[name="reg"], input#reg');
    var plate = normalisePlate(input && input.value);
    if (!plate || !image) return;
    writeInfo({ registration: plate, image: image, capturedAt: Date.now() });
  }, true);

  if (!/^\/collections\/wipers-for-your-vehicle\/?$/.test(window.location.pathname)) return;

  function insertWhenReady() {
    var plateNode = document.querySelector('#your-vehicle .icon-reg .your-vehicle__reg');
    if (!plateNode) return false;
    var currentPlate = normalisePlate(plateNode.textContent);
    if (!currentPlate) return true;

    var info = readStoredInfo();
    if (!info) {
      info = imageFromRegResult(currentPlate);
      if (info) writeInfo(info);
    }
    if (!info || normalisePlate(info.registration) !== currentPlate) return true;

    var image = validatedImageUrl(info.image);
    if (!image) return true;
    var wrapper = plateNode.closest('.icon-reg');
    if (!wrapper || wrapper.querySelector('.vipa-confirmed-vehicle-photo')) return true;

    var photo = document.createElement('img');
    photo.className = 'vipa-confirmed-vehicle-photo';
    photo.width = 176;
    photo.height = 116;
    photo.alt = 'Vehicle image for registration ' + plateNode.textContent.trim();
    photo.decoding = 'async';
    photo.loading = 'eager';
    photo.addEventListener('load', function () {
      if (plateNode.isConnected && normalisePlate(plateNode.textContent) === currentPlate) {
        wrapper.insertBefore(photo, plateNode);
      }
    }, { once: true });
    photo.addEventListener('error', function () { photo.remove(); }, { once: true });
    photo.src = image;
    return true;
  }

  if (insertWhenReady()) return;
  var watcher = new MutationObserver(function () {
    if (insertWhenReady()) watcher.disconnect();
  });
  watcher.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(function () { watcher.disconnect(); }, 20000);
})();

/* VIPA vehicle selector presentation hook; does not change finder data or callbacks. */
(function(){
  'use strict';
  var scheduled=false;
  function decorate() {
    if(!document.body)return;
    var confirm=document.querySelector('.vehicle-confirm__modal .vehicle-confirm__block');
    if(confirm)confirm.classList.add('vipa-finder-confirm-panel');
    document.querySelectorAll('select[name="make"]').forEach(function(select){
      var parent=select.parentElement;
      for(var level=0;parent&&parent!==document.body&&level<12;level++,parent=parent.parentElement){
        if(!parent.querySelector('select[name="model"]') || !parent.querySelector('select[name="body-style"]'))continue;
        var headings=parent.querySelectorAll('h1,h2,h3'),found=false;
        for(var i=0;i<headings.length;i++){
          if(/^select your vehicle$/i.test((headings[i].textContent||'').trim())){found=true;break;}
        }
        if(!found)continue;
        var width=parent.getBoundingClientRect().width;
        if(width>180 && width<Math.min(900,window.innerWidth*.85))parent.classList.add('vipa-finder-manual-panel');
        break;
      }
    });
  }
  function schedule(){
    if(scheduled)return;
    scheduled=true;
    requestAnimationFrame(function(){scheduled=false;decorate();});
  }
  function init(){
    decorate();
    if(!document.querySelector('.reg-finder-container'))return;
    document.addEventListener('click',function(e){
      if(e.target && e.target.closest && e.target.closest('.reg-finder-container, .vehicle-confirm__modal')){
        schedule();setTimeout(decorate,160);setTimeout(decorate,500);
      }
    },true);
    new MutationObserver(function(){
      if(document.querySelector('.vehicle-confirm__modal')||document.querySelector('select[name="make"]'))schedule();
    }).observe(document.body,{childList:true,subtree:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
